<template>
  <el-container>
    <el-main>
      <el-card>
        <div>
          <span>设备名称:<el-input v-model="pointName" style="width: 200px" clearable></el-input></span>
          <span style="margin-left:20px">设备类型:<el-select v-model="alarmPointType" clearable>
            <el-option v-for="item in pointType" :label="item" :value="item"></el-option>
          </el-select></span>
          <span style="margin-left:20px">群号:<el-input v-model="groupId" style="width: 200px" clearable></el-input></span>
          <span style="margin-left:20px">回示状态:<el-select v-model="isReturnNormal" clearable>
            <el-option v-for="item in isNormal" :label="item" :value="item"></el-option>
          </el-select></span>
          <el-date-picker  type="datetimerange"
                           align="right"
                           unlink-panels
                           range-separator="至"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期"
                           :picker-options="pickerOptions"
                           :default-time="['00:00:00', '23:59:59']"
                           style="margin-left: 20px"
                           v-model="startAndEndTime"
                           value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <el-button type="primary" @click="getreturnRecord(2)" style="margin-left:20px">搜索</el-button>
          <el-button type="info" @click="reset()">重置</el-button>
<!--          <span style="margin-left:20px">开始时间:<el-date-picker v-model="startTime" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptionsStart2"></el-date-picker></span>-->
<!--          <span style="margin-left:20px">结束时间:<el-date-picker v-model="endTime" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptionsEnd2"></el-date-picker></span>-->
        </div>
        <div style="margin-top:20px">
          <el-table :data="returnRecordList">
            <el-table-column label="设备名称" prop="pointName"></el-table-column>
            <el-table-column label="设备类型" prop="alarmPointType"></el-table-column>
            <el-table-column label="区域名称" prop="areaName"></el-table-column>
            <el-table-column label="回示时间" prop="backTime"></el-table-column>
            <el-table-column label="群号" prop="groupId" width="50px"></el-table-column>
            <el-table-column label="群内序号" prop="groupNum" ></el-table-column>
            <el-table-column label="指令码" prop="orderCode" ></el-table-column>
            <el-table-column label="状态码" prop="stateCode" ></el-table-column>
            <el-table-column label="设备ID" prop="devID" v-if="false"></el-table-column>
<!--            <el-table-column label="回示ID" prop="sendId"></el-table-column>-->
          </el-table>
          <div class="pagination">
            <el-pagination
              @current-change="getreturnRecord(1)"
              background
              layout="prev, pager, next"
              :page-size="10"
              :total="totalCount1*10"
              :current-page.sync="getReturnRecordList.params.pageNumber">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'ReturnRecord',
    data(){
      return{
        startAndEndTime:[new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),0,0,0).format('Y-m-d H:i:s'),new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),23,59,59).format('Y-m-d H:i:s')],
        isReturnNormal:'',
        totalCount1:'',
        isNormal:['误鸣上报','正常回示'],
        pointName:'',
        orderName:'',//指令名称
        orderType:'',//指令类型
        groupId:'',//群号
        alarmTypeList:['点呼','群呼','组呼','全呼'],
        alarmPointType:'',
        pointType:['电动控制器','电声控制器','一体机','多媒体','其他'],
        startTime:'',
        endTime:'',
        returnRecordList:[],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        getAlarmNameList:{
          "version": 1,
          "method": "rfalarm.GetOrderCode",
          "params": {},
          "token": "#",
          "id": 0
        },
        getReturnRecordList:{
          "version": 1,
          "method": "rfalarm.GetBackupAlarm",
          "params": {
            "pageNumber": 1,
	          "sendId":"",
            "orderName":"",
            "groupId":"" ,
            "stateCode":"" ,
            "startTime":"" ,
            "endTime":"" ,
            "pointName":"",
            "areaId":"",
            "alarmPointType":"",
          },
        "token": "#",
        "id": 0
      },
        }
    },
    methods:{
      getAlarmName(){
        this.$axios.post(this.$mainUrl,this.getAlarmNameList).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.alarmNameList = res.data.result.OrderNameList
          }
        })
      },
      getreturnRecord(val){
        if(this.isReturnNormal == ''){
          this.getReturnRecordList.params.sendId = null;
        }
        if(this.isReturnNormal == '正常回示'){
          this.getReturnRecordList.params.sendId = '2';
        }
        if(this.isReturnNormal == '误鸣上报'){
          this.getReturnRecordList.params.sendId = '1';
        }
        if(val == 2){
          this.getReturnRecordList.params.pageNumber = 1;
        }
        this.getReturnRecordList.params.pointName = this.pointName;
        this.getReturnRecordList.params.alarmPointType = this.alarmPointType;
        this.getReturnRecordList.params.groupId = parseInt(this.groupId);
        if(this.startAndEndTime == null){
          this.getReturnRecordList.params.startTime = null;
          this.getReturnRecordList.params.endTime = null;
        }else{
          this.getReturnRecordList.params.startTime = this.startAndEndTime[0];
          this.getReturnRecordList.params.endTime = this.startAndEndTime[1];
        }
        for (let val in this.getReturnRecordList.params){
          if(this.getReturnRecordList.params[val] === ""){
            this.getReturnRecordList.params[val] = null;
          }
        };
        this.$axios.post(this.$mainUrl,this.getReturnRecordList).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.returnRecordList = res.data.result.backupList
            this.totalCount1 = res.data.result.page;
          }
        })
      },
      reset(){
        this.pointName= '';
        this.alarmPointType = '';
        this.groupId = '';
        this.isReturnNormal ='';
        this.startAndEndTime = [];
      }
    },
    mounted () {
      this.getreturnRecord(1);
    }
  }
</script>

<style scoped>

</style>
